// extracted by mini-css-extract-plugin
module.exports = {"optionDetails":"styles_optionDetails__2rFV9","zeroOptionChangesRemaining":"styles_zeroOptionChangesRemaining__UfwSm","detailsTitle":"styles_detailsTitle__20yWU"};